import { merge, extend } from 'lodash'

import API from 'shared/lib/api'

export default {

  // Create resource on the API.
  //
  // @example
  //   SomeModel.actions.create({ id: Date.now(), attributes: { name: 'some name' } })
  //
  actionMethod: (model, options = {}) => {
    options = merge({}, options)
    options[model.singularName] = options.attributes
    options.apiVersion = options.apiVersion ?? model.options.apiVersion

    return API.createResource(model.pluralName, options)
  },

  // Updates record (optimistically) in the collection.
  //
  reduceMethod: (model, collection, action) => {
    const options = action?.payload?.options || {}
    const id = options.id

    switch (action.type) {
      case model.actionTypes.CREATE_START:
        if (options.id) {
          // Set create flags
          const attributes = { id: options.id, isBusy: true, pendingCreate: true }

          // Create temporary record with attributes
          if (options.attributes) {
            extend(attributes, options.attributes)
          }

          // Add it
          collection = collection.add(options.id, attributes, { temporary: true })
        }

        return collection

      case model.actionTypes.CREATE_ERROR:
        if (options.id) {
          const attributes = { isBusy: false, pendingCreate: true, hasError: true, errorData: action?.payload?.error }

          // Set error flag
          collection = collection.update(options.id, attributes)
        }

        return collection

      case model.actionTypes.CREATE_SUCCESS:
        if (options.id) {
          // Store tempID on record
          if (action?.payload?.records) {
            const recordID = Object.keys(action.payload.records)[0]
            collection = collection.update(recordID, { tempID: id })
          }

          // Delete temporary object
          collection = collection.delete(options.id)
        }

        return collection
    }
  }
}
